package com.exura.features.newauth.presentation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.exura.features.newauth.domain.manager.AuthManager
import com.exura.features.newauth.domain.model.AuthState
import com.exura.navigation.Route
import com.exura.navigation.navigateTo
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach
import org.koin.core.context.GlobalContext.get

@Composable
internal fun HandleSession(
    context: PageContext,
    loggedInDestination: String = context.route.toString(),
) {
    LaunchedEffect(Unit) {

        val authManager: AuthManager = get().get()

        authManager.state
            .onEach { state ->
                when (state) {
                    AuthState.Loading -> Unit

                    AuthState.Unauthenticated -> context.navigateTo(
                        pathQueryAndFragment = Route.LOGIN,
                        updateHistoryMode = UpdateHistoryMode.REPLACE,
                    )

                    is AuthState.Authenticated -> context.navigateTo(
                        pathQueryAndFragment = loggedInDestination,
                    )
                }
            }
            .launchIn(this)
    }
}
